import { render, staticRenderFns } from "./InsurerUsers.vue?vue&type=template&id=af95360e&"
import script from "./InsurerUsers.vue?vue&type=script&lang=js&"
export * from "./InsurerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports